import React, { useState } from "react";
import classes from "./FileDetailsSidebar.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  closeFileSideBar,
  openFileSideBar,
  setFileDetails,
} from "../../store/state-slices/fileDetailsSidebar";
import { Icon } from "@jds/core";
import {
  addParamsURL,
  bytesToHumanReadable,
  getArrtoDate,
} from "../../util/helper";

import brokenImg from "../../assets/png/brokenImg.png";

import decryptUrl from "../../util/img-decryption";

export default function FileDetailsSidebar() {
  const { isFileSideBarOpen, fileDetails } = useSelector(
    (state) => state.fileDetailsSideBar,
  );
  const dispatch = useDispatch();
  return (
    <>
      {/* Overlay */}
      {isFileSideBarOpen && (
        <div
          className={`${classes["overlay"]}`}
          onClick={() => {
            dispatch(setFileDetails(undefined));
            dispatch(closeFileSideBar());
          }}
        />
      )}

      {/* Side Panel */}
      <div
        className={`${classes["side-panel"]} ${isFileSideBarOpen ? classes["open"] : ""}`}
      >
        <div className={`${classes["header"]}`}>
          <p>Image Info</p>

          <span title="close">
            <Icon
              ic={"IcCloseRemove"}
              onClick={() => {
                dispatch(setFileDetails(undefined));
                dispatch(closeFileSideBar());
              }}
            />
          </span>
        </div>

        <div className={`${classes["content"]}`}>
          <div
            className={classes["img-card"]}
            style={{
              backgroundImage: `url(${addParamsURL(
                decryptUrl(fileDetails?.thumbnailFileSignedPath),
                { size: "m" },
              )})`,
            }}
          >
            <img
              src={addParamsURL(
                decryptUrl(fileDetails?.thumbnailFileSignedPath),
                {
                  size: "m",
                },
              )}
              draggable={false}
              onError={(e) => {
                // setErrorImg(true);
                e.target.src = brokenImg;
              }}
            />
          </div>
          <div className={`${classes["tabs"]}`}>
            <span className={`${classes["tabs-title"]}`}>Details</span>
          </div>
          <div className={`${classes["file-detail-container"]}`}>
            <div className={`${classes["file-detail"]}`}>
              <span className={`${classes["file-detail-title"]}`}>Name:</span>
              <span className={`${classes["file-detail-info"]}`}>
                {fileDetails?.fileName}
              </span>
            </div>
            <div className={`${classes["file-detail"]}`}>
              <span className={`${classes["file-detail-title"]}`}>Size:</span>
              <span className={`${classes["file-detail-info"]}`}>
                {bytesToHumanReadable(fileDetails?.fileSize)}
              </span>
            </div>
            <div className={`${classes["file-detail"]}`}>
              <span className={`${classes["file-detail-title"]}`}>
                Upload By:
              </span>
              <span className={`${classes["file-detail-info"]}`}>
                {fileDetails?.userName} ({fileDetails?.uploaderType})
              </span>
            </div>
            <div className={`${classes["file-detail"]}`}>
              <span className={`${classes["file-detail-title"]}`}>
                Uploaded On:
              </span>
              <span className={`${classes["file-detail-info"]}`}>
                {getArrtoDate(fileDetails?.createdAt || [])}
              </span>
            </div>
            <div className={`${classes["file-detail"]}`}>
              <span className={`${classes["file-detail-title"]}`}>
                Dimensions:
              </span>
              <span className={`${classes["file-detail-info"]}`}>
                {fileDetails?.metaInfo?.width || "-"} *{" "}
                {fileDetails?.metaInfo?.height || "-"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
